import React from "react";
import { TextField } from "@material-ui/core";

function StyledTextField({ ...rest }) {
  return <TextField size="small" fullWidth variant="outlined" {...rest} />;
}

export default React.memo(StyledTextField);
